import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import VPN360Ad from '../VPN360Ad';

export const Footer = () => {
  return (
    <footer className="bg-primary text-primary-foreground">
      <VPN360Ad variant="strip" />
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="/iaasp_logo.png" 
                alt="IAASP Logo" 
                className="w-12 h-12 object-contain"
              />
              <span className="text-xl font-heading font-bold">IAASP Academy</span>
            </div>
            <p className="text-sm text-primary-foreground/80">
              International Alliance of Advanced Security Programs. Centro de investigación en seguridad estratégica que promueve nuevas tendencias de pensamiento en la protección de personas.
            </p>
          </div>

          <div>
            <h3 className="font-heading font-bold mb-4">Enlaces Rápidos</h3>
            <div className="flex flex-col gap-2">
              <Link to="/courses" className="text-sm hover:text-accent transition-colors">
                Cursos
              </Link>
              <Link to="/becas" className="text-sm hover:text-accent transition-colors">
                🎓 Becas disponibles
              </Link>
              <Link to="/articulos" className="text-sm hover:text-accent transition-colors">
                Artículos
              </Link>
              <Link to="/verify" className="text-sm hover:text-accent transition-colors">
                Verificar Certificado
              </Link>
              <Link to="/about" className="text-sm hover:text-accent transition-colors">
                Nosotros
              </Link>
              <Link to="/contact" className="text-sm hover:text-accent transition-colors">
                Contacto
              </Link>
            </div>
          </div>

          <div>
            <h3 className="font-heading font-bold mb-4">Contacto</h3>
            <div className="flex flex-col gap-2 text-sm text-primary-foreground/80">
              <div className="flex items-center gap-2">
                <Mail className="w-4 h-4" />
                <span>contacto@iaaspacademy.com</span>
              </div>
              <div className="flex items-center gap-2">
                <Phone className="w-4 h-4" />
                <span>+54 11 1234-5678</span>
              </div>
              <div className="flex items-center gap-2">
                <MapPin className="w-4 h-4" />
                <span>Buenos Aires, Argentina</span>
              </div>
            </div>
          </div>

          <div>
            <h3 className="font-heading font-bold mb-4">Legal</h3>
            <div className="flex flex-col gap-2">
              <Link to="/politica-de-datos" className="text-sm hover:text-accent transition-colors" data-testid="footer-privacy-link">
                Política de Tratamiento de Datos
              </Link>
              <Link to="/contact" className="text-sm hover:text-accent transition-colors">
                Contacto Legal
              </Link>
            </div>
          </div>
        </div>

        <div className="border-t border-primary-foreground/20 mt-12 pt-8 text-center text-sm text-primary-foreground/60">
          <p>© {new Date().getFullYear()} IAASP Academy. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
};
